
import { EnhancedUploadArea } from "../../storage/EnhancedUploadArea";
import { useImageUpload } from "@/hooks/useImageUpload";

interface ThumbnailUploadProps {
  currentPath?: string;
  onPathChange: (path: string) => void;
  disabled?: boolean;
}

export const ThumbnailUpload = ({ 
  currentPath, 
  onPathChange, 
  disabled 
}: ThumbnailUploadProps) => {
  const {
    uploading,
    currentUrl,
    uploadFile,
    clearImage,
    handleUrlInput,
  } = useImageUpload({
    bucketName: 'episode-thumbnails',
    onPathChange,
    currentPath,
  });

  const handleFileUpload = (file: File) => {
    uploadFile(file);
  };

  const handleFileSelect = (bucketName: string, fileName: string) => {
    // Convert the selected file to a path format
    const filePath = fileName.startsWith('/') ? fileName : `/${fileName}`;
    onPathChange(filePath);
  };

  const handlePathChange = (path: string) => {
    handleUrlInput(path);
  };

  return (
    <div className="space-y-2">
      <EnhancedUploadArea
        label="Thumbnail"
        onFileUpload={handleFileUpload}
        onFileSelect={handleFileSelect}
        onPathChange={handlePathChange}
        uploading={uploading}
        acceptedTypes={['.jpg', '.jpeg', '.png', '.webp', '.gif']}
        allowedBuckets={['episode-thumbnails']}
        showBrowseOption={true}
        showPathInput={true}
        currentPath={currentPath || ''}
      />

      {/* Preview */}
      {currentUrl && (
        <div className="mt-2">
          <div className="relative inline-block">
            <img
              src={currentUrl}
              alt="Thumbnail preview"
              className="h-20 w-32 object-cover rounded border"
              onError={(e) => {
                console.error("Failed to load thumbnail preview");
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
